function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 1152.5,
  cy: 112.5,
  r: 112.5,
  fill: "#003CE6"
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 1302.5,
  cy: 242.5,
  r: 62.5,
  fill: "#00D4FF"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M80.5 266H182L167.5 347H266.5L252 432H156C149.333 479.833 133.5 570 133.5 578C133.5 637.5 207.333 623.5 243 615L228.5 702.5C228.5 705.5 195 714.5 160 714.5C40 714.5 22 628.5 28 585.5L52.5 432H0L15 347H66L80.5 266Z",
  fill: "#003CE6"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M390 348H307.5L253 709.5H357L357.463 706.216C365.145 651.752 380.769 540.979 389 501C417.4 433 482.167 433 510.5 442.5C513.667 421.833 520.3 371 525.5 345C468.5 327.5 413 366.5 392 398L390 348Z",
  fill: "#003CE6"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M948 350H840.5L923 709.5H1033.5L1218.5 350H1107.5L992.5 604.5L948 350Z",
  fill: "#003CE6"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M1340 349.5H1236L1176 708.5H1279.5L1340 349.5Z",
  fill: "#003CE6"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M839 559.5H597.5C604.5 614.5 664 677 815 606.5C810.6 632.9 803.833 674.5 801 692C739.5 720 628 741.5 551.5 680C502.7 635.6 495.833 574.167 498.5 549C497.5 515.333 514.1 433 588.5 373C635.5 337.5 682.5 334 732.5 344C772.179 351.936 814.2 376.2 839 433C849 458.5 850 512.5 839 559.5ZM598.5 497H750.5C760 470 749 422 689 422C641 422 605 468.5 598.5 497Z",
  fill: "#003CE6"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1268 757.5H1167.5L1156.5 812.5C1146.83 790.833 1110 747.5 1040 747.5C939.5 747.5 869.973 858.952 862 929C855 990.5 857.5 1124 1010.5 1124C1052.51 1124 1099.5 1092.5 1116 1064C1116 1066.79 1115.02 1072.84 1113.68 1081.17C1112.14 1090.74 1110.1 1103.34 1108.5 1117.5H1207.5L1268 757.5ZM965.5 929C969.167 899.833 994.6 841.5 1067 841.5C1118.5 841.5 1138 890 1134.5 929C1131.5 956 1106.5 1047 1013.5 1027C966.5 1008 960.5 963.5 965.5 929Z",
  fill: "#00D4FF"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M1389.5 757H1284L1366.5 1093.5L1283 1252.5H1394L1667 757H1554L1438.5 990.5L1389.5 757Z",
  fill: "#00D4FF"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M492 757H588.5L580.5 813C591.667 791.167 632.5 747.5 706.5 747.5C770 747.5 840 808 840 905C840 1023.5 762 1123 664.5 1125.5C589.525 1127.42 563.5 1083.5 550.5 1060.5L521.5 1252H416.5L492 757ZM566.88 931.677C571.29 888.677 606.48 836.577 664.88 840.177C717.38 843.677 742.979 883.677 732.88 943.677C724.38 994.177 676.38 1041.18 625.38 1030.68C581.654 1021.67 561.393 985.177 566.88 931.677Z",
  fill: "#00D4FF"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M1473.66 1207.96V1198.45H1518.46V1207.96H1501.76V1253H1490.36V1207.96H1473.66ZM1525.84 1198.45H1540.06L1555.08 1235.1H1555.72L1570.74 1198.45H1584.96V1253H1573.78V1217.5H1573.33L1559.21 1252.73H1551.59L1537.48 1217.36H1537.02V1253H1525.84V1198.45Z",
  fill: "#003CE6"
});

function SvgTrevipay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1667,
    height: 1271,
    viewBox: "0 0 1667 1271",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrevipay);
export default __webpack_public_path__ + "static/media/trevipay.a6465fae.svg";
export { ForwardRef as ReactComponent };